<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import IconWithTooltip from "@shared/svelte/Components/Popover/IconWithTooltip.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { DistributorEntity, ProductLineEntity } from "@shared/services/event_tracking/entities";

  export let title: string;
  export let targetObjectType: string;
  export let source: "Supplier" | "Distributor";
  export let url: string;
  export let productLineId: number;
  export let distributorId: number;

  const { trackClick, trackMrcEvents } = EventTracking;

  let trackingParams: (ProductLineEntity | DistributorEntity)[] = [
    new ProductLineEntity({ productLineId }),
  ];

  if (distributorId && source === "Distributor") {
    trackingParams.push(new DistributorEntity({ id: distributorId }));
  }

  const icon = {
    type: "Save",
    width: "24",
    height: "24",
  };

  const handleClick = () => {
    trackClick(targetObjectType, trackingParams);
    window.open(url, "_blank");
  };

  const handleEnter = (e: KeyboardEvent) => {
    if (e.code === "Enter") {
      handleClick();
    }
  };
</script>

<style>
  .download-card {
    height: 52px;
    cursor: pointer;
  }
  .document-icon:hover {
    background: #f1f6fb;
  }
</style>

<div
  use:trackMrcEvents={[trackingParams]}
  class="fizz-bordered fizz-inset-square-8 fizz-flex fizz-flex-row fizz-align-self-center fizz-space-between download-card fizz-text-subdued"
  on:click={handleClick}
  on:keydown={handleEnter}
>
  <span class="fizz-flex-row">
    <div class="fizz-icon-button document-icon fizz-inline-8 fizz-surface-blue">
      <Icon type={"Document"} height="24" width="24" fill="#127CA5" />
    </div>
    <strong class="fizz-text-body">{`${title}`}&nbsp;</strong>
    {`from ${source}`}
  </span>
  <span class="fizz-inline-8">
    <IconWithTooltip {icon} tooltip="Download" showTip tooltipClasses="fizz-surface-gray-inverse" />
  </span>
</div>
